<template>
  <span></span>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-ratings-tags',
  props: {
    writeReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    likeReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    readReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    sortReviewsTags: {
      type: Object,
      default() {
        return {};
      },
    },
    productName: {
      type: String,
      required: true,
    },
    postReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    productId: {
      type: String,
      required: true,
    },
    unhelpfulReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      overallRatingReview: 0,
    };
  },
  created() {
    if (this.writeReviewTags) {
      eventBus.on('WriteReviewTags', (val) => {
        this.datalayerEventsTrigger(this.writeReviewTags, val);
      });
    }
    if (this.likeReviewTags) {
      eventBus.on('LikeReviewTags', () => {
        this.datalayerEventsTrigger(this.likeReviewTags, '');
      });
    }
    if (this.unhelpfulReviewTags) {
      eventBus.on('unLikeReviewTags', () => {
        this.datalayerEventsTrigger(this.unhelpfulReviewTags, '');
      });
    }
    if (this.readReviewTags) {
      eventBus.on('readReviewTags', () => {
        this.datalayerEventsTrigger(this.readReviewTags, '');
      });
    }
    if (this.sortReviewsTags) {
      ['sortReviewsTags', 'filter-action-triggered'].forEach((eventItem) => {
        eventBus.on(eventItem, (displayDatas) => {
          this.datalayerEventsTrigger(this.sortReviewsTags, displayDatas);
        });
      });
    }
    if (this.postReviewTags) {
      eventBus.on('PostReviewTags', (noOfStars) => {
        this.overallRatingReview = noOfStars;
        this.datalayerEventsTrigger(this.postReviewTags, noOfStars);
      });
    }
  },
  methods: {
    datalayerEventsTrigger(tags, values) {
      var originalMsg = JSON.stringify(tags);
      if (originalMsg.includes('[page category]')) {
        if (window.wsf.pageCategory != undefined) {
          originalMsg = originalMsg.replaceAll(
            '[page category]',
            window.wsf.pageCategory.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll('[page category]', '');
        }
      }
      if (originalMsg.includes('[cta name]')) {
        if (values != undefined) {
          originalMsg = originalMsg.replaceAll('[cta name]', values.toLowerCase());
        } else {
          originalMsg = originalMsg.replaceAll('[cta name]', '');
        }
      }
      if (originalMsg.includes('[review selection]')) {
        if (values != undefined) {
          originalMsg = originalMsg.replaceAll('[review selection]', values.toLowerCase());
        } else {
          originalMsg = originalMsg.replaceAll('[review selection]', '');
        }
      }
      if (originalMsg.includes('[product name]')) {
        if (this.productName != undefined) {
          originalMsg = originalMsg.replaceAll('[product name]', this.productName.toLowerCase());
        } else {
          originalMsg = originalMsg.replaceAll('[product name]', '');
        }
      }
      if (originalMsg.includes('[product id]')) {
        if (this.productId != undefined) {
          originalMsg = originalMsg.replaceAll('[product id]', this.productId);
        } else {
          originalMsg = originalMsg.replaceAll('[product id]', '');
        }
      }
      if (originalMsg.includes('[number of stars]')) {
        if (this.overallRatingReview != undefined) {
          originalMsg = originalMsg.replaceAll('[number of stars]', this.overallRatingReview);
        } else {
          originalMsg = originalMsg.replaceAll('[number of stars]', '');
        }
      }
      /* istanbul ignore next */
      if (window.dataLayer !== undefined) {
        originalMsg = originalMsg.replaceAll('\n', '');
        /* istanbul ignore next */
        dataLayer.push(JSON.parse(originalMsg)); // eslint-disable-line no-undef
      }
    },
  },
};
</script>
